Wee.fn.make('project', {
    init: function() {
        var priv = this.$private;

        priv.initDropdowns();
        priv.initEvents();
    }
}, {
    /**
     * Init dropdowns
     *
     * @private
     */
    initDropdowns: function() {
        var org = Wee.fn.dropdown(),
            project = Wee.fn.dropdown(),
            routeLength = $.routes.segments().length;

        org.init({
            selector: 'ref:organizationDropdown',
            isSelected: routeLength > 1 && this.notPaginated(1),
            appPrefix: 'organization',
            rootModifier: '-project',
            placeholder: 'Organization Type'
        });

        project.init({
            selector: 'ref:projectTypeDropdown',
            isSelected: routeLength > 2 && this.notPaginated(2),
            appPrefix: 'projectType',
            rootModifier: '-project',
            placeholder: 'Project Type'
        });
    },

    /**
     * Init events
     *
     * @private
     */
    initEvents: function() {
        $('ref:projectSubmitButton').on('click', function(e) {
            var segments = $('ref:projectDropdown').map(function(el) {
                return $(el).val();
            });

            if (segments[1] && !segments[0]) {
                segments[0] = 'all';
            }

            window.location.href = '/projects' + (segments[0] ? '/' + segments.join('/') : '');

            e.preventDefault();
        });
    },

    /**
     * Check if a segment is a paginated page
     *
     * @param {number} segment
     * @returns {boolean}
     */
    notPaginated: function(segment) {
        return /^P[\d]+$/.test($.routes.segments(segment)) === false;
    }
});